<template>
  <div>
    <v-row class="px-5 py-5">
      <v-col cols="12" lg="3" md="6" sm="6">
        <card-widget
          icon="mdi-currency-usd"
          label="Gross Total"
          :value="loadingData ? 0 : summary.grossTotal"
          cardColor="primary"
          iconColor="white"
          textColor="white--text"
        ></card-widget>
      </v-col>
      <v-col cols="12" lg="3" md="6" sm="6">
        <card-widget
          icon="mdi-currency-usd"
          label="Direct Load"
          :value="loadingData ? 0 : summary.directLoadTotal"
          :dark="true"
          cardColor="primary"
          iconColor="white"
          textColor="white--text"
        ></card-widget>
      </v-col>
      <v-col cols="12" lg="3" md="6" sm="6">
        <card-widget
          icon="mdi-currency-usd"
          label="Has Direct Load"
          :value="loadingData ? 0 : summary.hasDirectLoadCount"
          :dark="true"
          cardColor="primary"
          iconColor="white"
          textColor="white--text"
        ></card-widget>
      </v-col>
      <v-col cols="12" lg="3" md="6" sm="6">
        <card-widget
          icon="mdi-currency-usd"
          label="No Direct Load"
          :value="loadingData ? 0 : summary.noDirectLoadCount"
          :dark="true"
          cardColor="primary"
          iconColor="white"
          textColor="white--text"
        ></card-widget>
      </v-col>
    </v-row>
    <v-data-table
      :page="table.page"
      :pageCount="table.numberOfPages"
      :options.sync="options"
      :server-items-length="table.total"
      :headers="table.headers"
      :items="table.data"
      :items-per-page="10"
      :loading="table.loading"
      item-key="id"
      loading-text="Loading... Please wait"
      :footer-props="{
        'items-per-page-options': [10, 50, 100, 250, -1],
      }"
      class="elevation-1 table-small-font"
      dense
    >
      <template
        v-for="header in table.headers.filter((header) =>
          header.hasOwnProperty('formatter')
        )"
        v-slot:[`item.${header.value}`]="{ value }"
      >
        {{ header.formatter(value) }}
      </template>

      <template v-slot:[`item.paymentStatus`]="{ item }">
        <a href="#" @click.prevent="viewDetails(item)">{{
          item.paymentStatus
        }}</a>
      </template>
    </v-data-table>

    <view-details-dialog ref="viewDetailsDialog"></view-details-dialog>
  </div>
</template>

<script>
import CardWidget from "@/components/CardWidget.vue";
import ViewDetailsDialog from "./ViewDetailsDialog.vue";
export default {
  components: { CardWidget, ViewDetailsDialog },
  data() {
    return {
      loadingData: true,
      summary: {},
      search: "",
      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,

        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Transaction Id",
            sortable: false,
            value: "transactionId",
          },
          {
            text: "Type",
            value: "type",
            sortable: false,
          },
          {
            text: "Currency",
            value: "currency",
            sortable: false,
          },
          {
            text: "Gross Amount",
            value: "grossAmount",
            sortable: false,
          },
          {
            text: "Fee",
            value: "fee",
            sortable: false,
          },
          { text: "Foreign Fee", value: "foreignFee", sortable: false },
          { text: "Dispute Fee", value: "disputeFee", sortable: false },
          { text: "Net Amount", value: "netAmount", sortable: false },
          { text: "Description", value: "description", sortable: false },
          { text: "Status", value: "status", sortable: false },
          { text: "Payment Id", value: "paymentId", sortable: false },
          { text: "Link Reference", value: "linkReference", sortable: false },
          {
            text: "Transaction Date",
            value: "transactionDate",
            sortable: false,
          },
          { text: "Payment Method", value: "paymentMethod", sortable: false },
          { text: "Payment Status", value: "paymentStatus", sortable: false },
        ],
        data: [],
      },

      options: {
        page: 1,
      },
    };
  },
  props: ["id", "topup"],
  methods: {
    async viewDetails(item) {
      this.$refs.viewDetailsDialog.open(item, "DIRECT_LOAD");
    },
    async getList() {
      this.table.loading = true;
      const { page, itemsPerPage } = this.options;
      let pageNumber = page ? page : 1;

      console.log(pageNumber, itemsPerPage);
      await this.$payment
        .get(
          `/verify-entry-transactions?transactionId=${this.$props.id}&topup=${this.$props.topup}&page=${pageNumber}&limit=${itemsPerPage}`
        )
        .then((response) => {
          this.table.loading = false;

          const newArr = response.data.data;
          this.table.total = newArr.total;
          this.table.numberOfPages = Math.ceil(newArr.total / itemsPerPage);
          this.loadingData = false;
          this.summary = newArr.summary;
          // console.log(newArr);
          this.table.data = newArr.list;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },
  },

  created() {
    // this.getList();
  },

  watch: {
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },
};
</script>

<style>
.table-small-font table tbody tr td {
  font-size: 0.8rem !important;
}
</style>
